export default __webpack_public_path__ + "static/media/warning--village--g1.186803fe.png";